import { SchemaStringDefinition } from './TypedDefinition'
import type { TString } from '@rehaje/shared'

export type FormatType = TString | keyof typeof defaultFormats

export type Formats = {
  [K in FormatType]?: RegExp
}

export const defaultFormats = {
  date: /^(?:18|19|20)\d{2}([-/]?)(0[1-9]|1[0-2])\1(0[1-9]|[12]\d|3[01])$/,
  datetime: /^(?:18|19|20)\d{2}([-/]?)(0[1-9]|1[0-2])\1(0[1-9]|[12]\d|3[01])[\sT]([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
  email: /^[a-zA-Z0-9]+(?:[._%+-][a-zA-Z0-9]+)*@(?:[a-zA-Z0-9]+(?:\.[a-zA-Z0-9]+)*\.[a-zA-Z]{2,})$/,
  enName: /^[A-Z][a-z]+(?:[-'\s][A-Z][a-z]*)*$/,
  float: /^-?(?:0|[1-9]\d*)(?:\.\d{1,16})?(?:[eE][-+]?\d{1,3})?$/,
  idcard: /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
  integer: /^-?(?:0|[1-9]\d{0,15})$/,
  ipv4: /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/,
  ipv6: /^(?:[0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$/,
  money: /^(?:[$€¥£₽](?:\s)?|(?:USD|EUR|JPY|GBP|CNY|HKD)\s)?(?:0|[1-9]\d{0,2}(?:,?\d{3})*)(?:\.\d{1,2})?$/,
  password: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  phone: /^(?:\+?86[-\s])?(?:1[3-9]\d{9}|(?:\d{3,4})-\d{8})$/,
  qq: /^[1-9][0-9]{4,9}$/,
  time: /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/,
  timestamp: /^(?:1[0-9]|2[01])\d{11}$/,
  url: /^https?:\/\/(localhost|[\da-zA-Z][-\da-zA-Z.]*\.[\da-zA-Z][-\da-zA-Z.]+)(?::\d{1,5})?(?:\/[^\s]*)?$/,
  username: /^[a-zA-Z][a-zA-Z0-9-_]{4,32}$/,
  zhName: /^[\u4e00-\u9fff]{2,20}$/,
  zip: /^\d{6}$/
} as const

SchemaStringDefinition.setFormats(defaultFormats)
